export class CardTracks {
    public tracks: string[];
    public constructor() { }
    public static OnDeserialized(instance: CardTracks, json: any): void {
        instance.tracks = [json.track_1, json.track_2, json.track_3];
    }
}
